import io from "socket.io-client";
import api from "../services/api";


class SocketWorker {
  constructor(companyId , userId) {
    let sessionToken = api.defaults.headers.Authorization

    // Tentar obter token do localStorage se não estiver no axios
    if (!sessionToken) {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          sessionToken = `Bearer ${JSON.parse(token)}`;
          api.defaults.headers.Authorization = sessionToken;
        } catch (e) {
          console.error("Erro ao parsear token do localStorage:", e);
        }
      }
    }

    // Validar se o token existe antes de criar o socket
    if (!sessionToken) {
      console.warn("SocketWorker: Token não disponível, socket não será criado");
      return SocketWorker.instance || this;
    }

    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = sessionToken
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    }

    return SocketWorker.instance;
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      // transports: ["websocket", "polling", "flashsocket"],
      // pingTimeout: 18000,
      // pingInterval: 18000,
      query: { userId: this.userId, token: this.token }
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
      this.reconnectAfterDelay();
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    this.connect();

    // Validar se socket foi criado com sucesso
    if (!this.socket) {
      console.error("SocketWorker.on: Socket não disponível, não é possível adicionar listener");
      return;
    }

    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento. O terceiro argumento, quando é função, é o callback de ACK
  // do socket.io: o servidor responde chamando-o, e a correlação entre pedido e
  // resposta é feita pela própria lib (sem inventar id de correlação).
  emit(event, data, ack) {
    this.connect();

    // Validar se socket foi criado com sucesso
    if (!this.socket) {
      console.error("SocketWorker.emit: Socket não disponível, não é possível emitir evento");
      return;
    }

    if (typeof ack === "function") {
      this.socket.emit(event, data, ack);
      return;
    }

    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    this.connect();

    // Validar se socket existe antes de tentar remover listeners
    if (!this.socket) {
      console.warn("SocketWorker.off: Socket não disponível, removendo apenas do cache local");
      // Remover do cache local mesmo sem socket
      if (this.eventListeners[event]) {
        if (callback) {
          this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
        } else {
          delete this.eventListeners[event];
        }
      }
      return;
    }

    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      this.instance = null
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;